/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_DecisionInputs */

const en_directory_detail_section_decision = /** @type {(inputs: Directory_Detail_Section_DecisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it for you`)
};

const zh_directory_detail_section_decision = /** @type {(inputs: Directory_Detail_Section_DecisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否适合你`)
};

/**
* | output |
* | --- |
* | "Is it for you" |
*
* @param {Directory_Detail_Section_DecisionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_decision = /** @type {((inputs?: Directory_Detail_Section_DecisionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_DecisionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_decision(inputs)
	return zh_directory_detail_section_decision(inputs)
});
export { directory_detail_section_decision as "directory.detail.section.decision" }